import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import {
  O2OPartnerBranchListingInterface,
  O2OPartnerProtectionListingInterface,
  O2OPartnerUserListingInterface
} from "../../interfaces/o2o-partner.interface";
import { PageEvent } from "@angular/material/paginator";
import {
  TableConfigDataInterface,
  TableConfigInterface,
  TableConfigType
} from "../../partner-details/partner-details.component";
import { PartnerStatus } from "../../../share/constants/partner-platform/partner-status";

@Component({
  selector: "app-partner-details-table",
  templateUrl: "./partner-details-table.component.html",
  styleUrls: ["./partner-details-table.component.scss"]
})
export class PartnerDetailsTableComponent implements OnInit, OnChanges {
  @Input() displayedColumns: string[] = [];
  @Input() config: TableConfigInterface;
  @Input() dataSource: TableConfigDataInterface[] = [];
  @Output() deleteEvent = new EventEmitter<string>();
  @Output() editEvent = new EventEmitter<string>();
  @Output() sendEmailEvent = new EventEmitter<string>();
  @Output() pageChangeEvent = new EventEmitter<PageEvent>();

  protected readonly PartnerStatus = PartnerStatus;
  protected readonly TableConfigType = TableConfigType;

  ngOnInit(): void {
    this.dataSource = this.config.data;
    this.displayedColumns = this.config.displayedColumns;
  }

  ngOnChanges(): void {
    if (this.config) {
      this.dataSource = this.config.data;
      this.displayedColumns = this.config.displayedColumns;
    }
  }

  delete(element: TableConfigDataInterface): void {
    this.deleteEvent.emit(element.id);
  }

  edit(element: TableConfigDataInterface): void {
    this.editEvent.emit(element.id);
  }

  sendEmail(element: TableConfigDataInterface): void {
    this.sendEmailEvent.emit(element.id);
  }

  pageChange(e: PageEvent): void {
    this.pageChangeEvent.emit(e);
  }

  asBranch(
    element: TableConfigDataInterface
  ): O2OPartnerBranchListingInterface {
    return element as O2OPartnerBranchListingInterface;
  }

  asUser(element: TableConfigDataInterface): O2OPartnerUserListingInterface {
    return element as O2OPartnerUserListingInterface;
  }

  asProtection(
    element: TableConfigDataInterface
  ): O2OPartnerProtectionListingInterface {
    return element as O2OPartnerProtectionListingInterface;
  }
}
